require([
    'services',
    'jquery',
    'semantic',
    'ch_semantic_wishlist',
    'ch_modal_window',
    'ch_header',
    'ch_semantic_responsive'
], function () {

    $('.ui.checkbox').checkbox();

    $('.student-picks').first().find('> .column').on('click', function(e) {
        var me = this;
        ga(
            'send',
            'event',
            'New category page - ' + CH.GA.page,
            'Merchandised course clicked',
            $(me).index() + 1,
            { nonInteraction: false }
        );
    });

    $('.art-categories > .column > .column').on('click', function(e) {
        var me = this;
        ga(
            'send',
            'event',
            'New category page - ' + CH.GA.page,
            'Subcategory image block clicked',
            $(me).index() + 1,
            { nonInteraction: false }
        );
    });

    $('.button-block a.button').on('click', function(e) {
        var me = this;
        ga(
            'send',
            'event',
            'New category page - ' + CH.GA.page,
            'Button clicked',
            $(me).text(),
            { nonInteraction: false }
        );
    });

    $('.last-minute-deals > .column').on('click', function(e) {
        var me = this;
        ga(
            'send',
            'event',
            'New category page - ' + CH.GA.page,
            'Deal course clicked',
            $(me).index() + 1,
            { nonInteraction: false }
        );
    });

    // Newsletter email capture
    CH.semantic_form_validation = true;
    CH.validate('form_CaptureEmail', {
        submitHandler: function (form) {

            $form = $(form);
            $form.addClass('loading');
            $.ajax({
                type: 'POST',
                url: form.action,
                data: $form.serialize(),
                xhrFields: {
                    withCredentials: true,
                },
                success: function (res) {

                    $form.removeClass('loading');

                    if (res.success) {

                        ga(
                            'send',
                            'event',
                            'Email Capture',
                            'Subscribe',
                            $._('funnel').val(),
                            { nonInteraction: false }
                        );

                        swal({
                            title: $form.data('success-message') || 'Thank You for subscribing!',
                            type: 'success',
                            confirmButtonText: 'OK',
                            closeOnConfirm: true,
                        }, function () {

                            var destination = $form.data('success-destination');

                            window.location = destination || window.location;

                        });

                    } else if (res.error) {
                        swal('Sorry, there was a problem submitting your email address', res.error, 'error');
                    }

                },
            });

        },
    });

});
